/**
 * Initializes a toggle-button built using the UIToggleButton PHP component.
 * @param {string} id The HTML ID attribute of the toggle button container
 * @param {{selector: string, cb: Function}[]} btns
 */
PMW.initToggleButton = function (id, btns) {
    const container = $(`#${id}`);
    PMW.onClick(container, '.js-toggle-btn:not(.-selected)', (e) => {
        const selectedBtn = $(e.currentTarget);
        selectedBtn.blur();
        selectedBtn
            .addClass('-selected')
            .siblings('.toggle-btn.-selected')
            .removeClass('-selected');

        if (selectedBtn.siblings('.slider').hasClass('-second-btn')) {
            selectedBtn.siblings('.slider').removeClass('-second-btn');
        } else {
            selectedBtn.siblings('.slider').addClass('-second-btn')
        }
    });

    const showAllContainer = $(`#${id}.-show-view-all`);
    PMW.onClick(showAllContainer, '.js-toggle-btn.-selected', (e) => {
        const selectedBtn = $(e.currentTarget);
        selectedBtn.find('.js-loader').removeClass('_hidden').siblings().addClass('_hidden');
        selectedBtn.blur();
        PMW.gtm.trackGA4CarouselToggleViewAllClick(selectedBtn.attr('data-analytics-name'));
        window.location = selectedBtn.attr('data-url');
    });

    if (btns.length > 0) {
        PMW.initCarouselToggle(btns);
    }
};